<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Cuentas
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Búsqueda"
              outlined
              dense
              hide-details
              clearable
            ></v-text-field>
            <v-btn
              style="float:right;"
              color="primary"
              dark
              class="ml-2"
              @click="mostrarModalCuenta = true"
              >Nueva cuenta</v-btn
            >
          </v-card-title>
          <v-alert v-if="mostrarErrorCarga" outlined type="error">
            Hubo un problema cargando la información, revise su conexión a internet e intente
            nuevamente.
          </v-alert>
          <v-data-table
            :loading="tableLoading"
            loading-text="Cargando... por favor espere."
            :headers="headers"
            :items="cuentaList"
            :search="search"
          >
            <template #item.actions="{ item }">
              <v-btn color="blue" @click="editarCuenta(item)" class="mr-2" text rounded dark>
                Editar
                <v-icon small class="mr-2">
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn color="red" @click="eliminarCuenta(item.ID)" rounded dark text>
                Borrar
                <v-icon small class="mr-2">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <ModalCuenta
      @muestraDialogExito="mostrarDialogExito($event)"
      @cerrar-modal-descuento="cerrarModalCuenta()"
      @muestraModalErrorEnAccion="mostrarModalErrorEnAccion($event)"
      :show="mostrarModalCuenta"
      v-if="mostrarModalCuenta"
      :cuentaPasada="objetoCuentaAEditar"
    />
    <ModalConfirmarEliminacion
      :show="dialogConfirmarEliminacion"
      v-if="dialogConfirmarEliminacion"
      @cerrarModalFraccion="dialogConfirmarEliminacion = false"
      @confirmarEliminacionFraccionA="confirmarEliminacionCuenta()"
    />
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
    <v-snackbar
      v-model="snackbarExito"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;">
        {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
      </span></v-snackbar
    >
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCuenta from "@/components/modales/ModalCuenta.vue";
import ModalConfirmarEliminacion from "@/components/modales/ModalConfirmarEliminacion.vue";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";

export default {
  data: () => ({
    mostrarErrorCarga: false,
    tableLoading: false,
    objetoCuentaAEditar: {},
    dialogConfirmarEliminacion: false,
    mensajeErrorModalErrorEnAccion: "",
    dialogErrorEnAccion: false,
    idItemABorrar: "",
    search: "",
    mostrarModalCuenta: false,
    snackbarExito: false,
    mensajeSnackbarExito: "",
    headers: [
      {
        text: "Cuenta",
        align: "center",
        sortable: true,
        value: "CUENTA"
      },
      {
        text: "Descripción",
        align: "center",
        sortable: true,
        value: "DESCRIPCION"
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions"
      }
    ]
  }),
  computed: {
    ...mapState("cuentas", {
      cuentaList: state => state.cuentas
    })
  },
  mounted() {
    this.obtenerCuentas();
  },
  components: {
    ModalCuenta,
    ModalConfirmarEliminacion,
    ModalErrorEnAccion
  },
  async beforeDestroy() {
    await this.destroyCuentas();
  },
  methods: {
    ...mapActions("cuentas", ["getCuentas", "deleteCuentas","destroyCuentas"]),

    async obtenerCuentas() {
      this.tableLoading = true;
      const res = await this.getCuentas();
      if (res[0]) {
        this.tableLoading = false;
        this.mostrarErrorCarga = false;
      } else if (res[1] === "errorcarga") {
        this.mostrarErrorCarga = true;
        this.tableLoading = false;
      }
    },
    cerrarModalCuenta() {
      this.mostrarModalCuenta = false;
      this.objetoCuentaAEditar = {};
    },
    async editarCuenta(CuentaAEditar) {
      this.mostrarModalCuenta = true;
      this.objetoCuentaAEditar = CuentaAEditar;
    },
    async confirmarEliminacionCuenta() {
      const res = await this.deleteCuentas(this.idItemABorrar);
      if (res[0]) {
        this.dialogConfirmarEliminacion = false;
        this.obtenerCuentas();
        this.snackbarExito = true;
        this.mensajeSnackbarExito = "Cuenta eliminada con éxito";
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
        this.dialogConfirmarEliminacion = false;
      }
    },
    mostrarDialogExito(mensaje) {
      this.cerrarModalCuenta();
      this.snackbarExito = true;
      this.mensajeSnackbarExito = mensaje;
      this.obtenerCuentas();
    },
    mostrarModalErrorEnAccion(mensaje) {
      this.dialogErrorEnAccion = true;
      this.mensajeErrorModalErrorEnAccion = mensaje;
    },
    eliminarCuenta(data) {
      this.idItemABorrar = data;
      this.dialogConfirmarEliminacion = true;
    }
  }
};
</script>
<style lang="css"></style>
